<div class="ui-figure-caption">
    <ng-content select="ui-figure-number"></ng-content>
    <ng-content select="ui-figure-text"></ng-content>
    <ng-content select="ui-figure-sub-text"></ng-content>
</div>
